import React from 'react';
import { subscribe } from 'react-contextual';
import { Col, Button } from 'reactstrap';
import Tag from '../../tag';
import onClickHandle from '../onClickHandle';

const getTags = (tags) => {
	let classCol = 'default tag-block d-flex justify-content-center mb-3 mobile-ls-w-50 ';
	if (tags.length > 2) {
		const stackClass = `stack-${tags.length}`;
		classCol += stackClass;
	}

	return (
		tags.map((item, index) => (
			<Col className={classCol} key={item.tag}>
				<a href={item.link} className="no-hover no-underline" onClick={(e) => onClickHandle(e, 'tag-panel-click', { index, tag: item.tag }, item.link)} style={{width:'100%'}}>
					<div className="d-flex tag-block-wrapper text-center p-3 h-100" style={{ width: '100%', flexDirection: 'column', justifyContent: 'space-between' }}>
						<Tag design="capsule" tag={item.tag} className="align-self-center" style={{ fontSize: '14px', marginBottom: '0.5rem' }} />
						<p className="tags-description d-flex">{item.description}</p>
						<Button className="btn btn-outline-dark">View All</Button>
					</div>
				</a>
			</Col>))
	);
};

const TagsBlock = ({
	tags
}) => (
	<React.Fragment>
		{getTags(tags)}
	</React.Fragment>
);


TagsBlock.defaultProps = {
	className: 'd-flex justify-content-center image-mw-50'
};

export default subscribe()(TagsBlock);
